import { TasksTable } from '../TasksTable'

const InProgressTasks = () => {
  return <TasksTable type='in_progress' />
}

export default InProgressTasks
